
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';
//```import constants types
import {
    VIDFLEET_INFORMATION_REQUEST,
    VIDFLEET_INFORMATION_SETTINGS_REQUEST,
    VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';

import {
    vidfleetInformationResult,
    vidfleetInformationSettingsResult,
    vidfleetGetClipTimeResult,
} from 'Redux/actions';

function* getVidFleetDeviceInfo({ payload }) {
    try {
        const { esn } = payload;

        let data = {};

        let QUERY_CAMERA_INFO = `
            query getCameraInfo($esn: String!){
                result: getCameraInfo(esn: $esn)
            }
        `

        let cameraInfo = yield call(
            clientQuery,
            QUERY_CAMERA_INFO,
            {
                esn: esn
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (cameraInfo?.result) {
            cameraInfo = JSON.parse(cameraInfo?.result)
            if (cameraInfo?.firmwareToUpgrade) {
                cameraInfo.firmwareToUpgrade = {
                    firmwareNew: cameraInfo.firmwareToUpgrade.firmware
                }
            }
            data.CameraInfo = cameraInfo;
        }

        let QUERY_DATA_USAGE = `
            query getCameraDataUsage($esn: String!){
                result: getCameraDataUsage(esn: $esn)
            }
        `

        let dataUsage = yield call(
            clientQuery,
            QUERY_DATA_USAGE,
            {
                esn: esn
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (dataUsage?.result) {
            dataUsage = JSON.parse(dataUsage?.result)
            data.CameraDataUsage = dataUsage;
        }

        let QUERY_CAMERA_STATUS = `
            query getCameraStatus($esn: String!){
                result: getCameraStatus(esn: $esn)
            }
        `

        let cameraStatus = yield call(
            clientQuery,
            QUERY_CAMERA_STATUS,
            {
                esn: esn
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (cameraStatus?.result) {
            cameraStatus = JSON.parse(cameraStatus?.result)
            data.CameraStatus = cameraStatus;
        }

        //repeated
        delete data.CameraStatus.sn;
        delete data.CameraStatus.sdCardStatus;

        //round
        if (data.CameraStatus.lastGps && data.CameraStatus.lastGps.heading)
            data.CameraStatus.lastGps.heading = Math.round((data.CameraStatus.lastGps.heading + Number.EPSILON) * 100) / 100;

        //round
        if (data.CameraStatus.signal && data.CameraStatus.signal.RSRP)
            data.CameraStatus.signal.RSRP = Math.round((data.CameraStatus.signal.RSRP + Number.EPSILON) * 100) / 100;

        yield put(vidfleetInformationResult(data));

    } catch (exc) {

        let errorResponse = exc;
        if (exc.request && exc.request.response)
            errorResponse = JSON.parse(exc.request.response)
        yield put(vidfleetInformationResult({ error: errorResponse }));
        ExceptionManager(
            exc,
            "",
            "getVidFleetDeviceInfo"
        )
    }
}

function* getVidFleetDeviceSettingsInfo({ payload }) {
    try {
        const { esn } = payload;

        let QUERY = `
            query getCameraSettings($esn: String!){
                result: getCameraSettings(esn: $esn)
            }
        `

        let data = yield call(
            clientQuery,
            QUERY,
            {
                esn: esn
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            let result = JSON.parse(data?.result)
            if (result?.settings) {
                yield put(vidfleetInformationSettingsResult(result?.settings))
            } else {
                yield put(vidfleetInformationSettingsResult(null))
            }
        } else {
            yield put(vidfleetInformationSettingsResult(null))
        }
    } catch (exc) {
        yield put(vidfleetInformationSettingsResult(null));
        ExceptionManager(
            exc,
            "",
            "getVidFleetDeviceSettingsInfo"
        )
    }
}

function* getClipTimeRange({ payload }) {
    try {
        const { id, preloaded } = payload;

        let QUERY = `
            query getAvailableClips ($unitId: Int!, $preloaded: Boolean) {
                result: getAvailableClips (unitId: $unitId, preloaded: $preloaded)
            }
        `
        let data = yield call(
            clientQuery,
            QUERY,
            {
                unitId: id,
                preloaded: preloaded
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            data = JSON.parse(data.result)
            yield put(vidfleetGetClipTimeResult(data))
        } else yield put(vidfleetGetClipTimeResult(null))


    } catch (exc) {
        yield put(vidfleetGetClipTimeResult(null));
        ExceptionManager(
            exc,
            "",
            "getClipTimeRange"
        )
    }
}


function* watchMethods() {
    yield takeEvery(VIDFLEET_INFORMATION_REQUEST, getVidFleetDeviceInfo);
    yield takeEvery(VIDFLEET_INFORMATION_SETTINGS_REQUEST, getVidFleetDeviceSettingsInfo);
    yield takeEvery(VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST, getClipTimeRange);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}